import React from 'react';
import * as Mui from '@mui/material';
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from './style';

interface Props extends OwnProps,
	WithStyles<typeof styles> {}

interface OwnProps {
	checked: boolean;
	onChange: (value: boolean) => void;
	label?: React.ReactNode;
	description?: string | React.ReactNode;
	labelBold?: boolean;
	disabled?: boolean;
}

const Component: React.FC<Props> = ({ classes = {}, checked, onChange, label, description, labelBold = true, disabled }) => {
	const hasDescription = !!description;
		return (
			<Mui.FormControlLabel
				className={hasDescription ? classes.label : undefined}
				classes={{ root: classes.root }}
				control={
					<Mui.Switch
						checked={checked}
						onChange={() => onChange(!checked)}
						disabled={disabled}
						name="featured"
						className={classes.switchColor}
						classes={{root: hasDescription ? classes.switch : undefined}}
					/>
				}
				label={
					<>
						{label && (
							<Mui.Typography
								className={classes.labelText}
								// A label that carries more than text (a tag beside it) can't sit in a <p>.
								component={typeof label === "string" ? "p" : "div"}
								style={{ fontWeight: labelBold ? "bold" : 400, fontSize: 16 }}
							>
								{label}
							</Mui.Typography>
						)}
						{description && (
							<Mui.Typography className={classes.descriptionText} style={{ fontSize: 16, marginTop: 4 }}>
								{description}
							</Mui.Typography>
						)}
					</>
				}
			/>
		);
};

export const Switch = withStyles(Component, styles);
